import { BiteLogElavonEvent } from './bite_log_elavon_event.js';

export function name(event: BiteLogElavonEvent): string {
  switch (event) {
    case BiteLogElavonEvent.None:
      return 'ok';
    case BiteLogElavonEvent.TerminalDisconnected:
      return 'terminal-disconnected';
    case BiteLogElavonEvent.TerminalConnected:
      return 'terminal-connected';
    case BiteLogElavonEvent.UpdateIdleTextError:
      return 'update-idle-text-error';
    case BiteLogElavonEvent.SaleTransaction:
      return 'transaction-sale';
    case BiteLogElavonEvent.SaleTransactionError:
      return 'transaction-sale-error';
    case BiteLogElavonEvent.NoResponseReceived:
      return 'no-response-received';
    case BiteLogElavonEvent.InquiryTransaction:
      return 'transaction-inquiry';
    case BiteLogElavonEvent.InquiryTransactionError:
      return 'transaction-inquiry-error';
    case BiteLogElavonEvent.CancelTransaction:
      return 'transaction-cancel';
    case BiteLogElavonEvent.CancelTransactionError:
      return 'transaction-cancel-error';
    case BiteLogElavonEvent.GetOrSaveReferenceSequenceFailed:
      return 'get-or-save-reference-sequence-failed';
    case BiteLogElavonEvent.OptConnectFailure:
      return 'opt-connect-failure';
  }
}
